import { FLAG_TONE } from '../lib/constants.js';

export function EventCard({ event }) {
  const impactTone = ({
    Critical: FLAG_TONE.red,
    High:     FLAG_TONE.yellow,
    Medium:   FLAG_TONE.blue,
    Low:      FLAG_TONE.gray,
  })[event.impact_level] || FLAG_TONE.gray;
  return (
    <div style={{
      background: '#e3f2fd', borderLeft: '3px solid #1565c0',
      padding: 12, borderRadius: 8, marginBottom: 8,
    }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a' }}>{event.event_name}</div>
      <div style={{ fontSize: 12, color: '#37474f', marginTop: 4, display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{
          display: 'inline-block', padding: '2px 8px', borderRadius: 10,
          background: impactTone.bg, color: impactTone.text, fontWeight: 600, fontSize: 11,
        }}>{event.impact_level || 'Medium'}</span>
        <span>{event.impact_direction || 'Impact'} impact</span>
      </div>
      {event.start_date && (
        <div style={{ fontSize: 11, color: '#607d8b', marginTop: 4 }}>{event.start_date}</div>
      )}
    </div>
  );
}
